import React from 'react';
import Head from 'next/head';

const ContentfulStructuredData = (
  schema: Record<string, unknown>,
): JSX.Element => {
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </Head>
  );
};

export default ContentfulStructuredData;
